import React, { useState } from 'react';
import CardFront from './CardFront';
import CardBack from './CardBack';

const BusinessCard = ({ profile, onCardClick }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleClick = () => {
    onCardClick(profile);
  };

  return (
    <div 
      className="card-container h-80 perspective-1000 cursor-pointer"
      onMouseEnter={() => setIsFlipped(true)}
      onMouseLeave={() => setIsFlipped(false)}
      onClick={handleClick}
    >
      <div className={`card-inner relative w-full h-full transition-transform duration-700 transform-style-3d ${isFlipped ? 'rotate-y-180' : ''}`}>
        <CardFront profile={profile} />
        <CardBack profile={profile} />
      </div>
    </div>
  );
};

export default BusinessCard;
